var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronBackward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: 20,
    height: 20,
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "chevron_backward"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_203",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "var(--fill-0, #D9D9D9)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chevron_backward_2",
    d: "M12 15.6667L6.33333 10L12 4.33333L13.7292 6.0625L9.79167 10L13.7292 13.9375L12 15.6667Z",
    fill: "var(--fill-0, #119ED9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBackward);
export default __webpack_public_path__ + "static/media/chevron_backward.8cc8a98890bbc5345db6f64502ee3073.svg";
export { ForwardRef as ReactComponent };